import pentagramDark from "./pentagram-dark.json";
import pentagramLight from "./pentagram-light.json";
import ltgDark from "./ltg-dark.json";
import blueprints from "./blueprints.json";

/**
 * NOTE: The "ghost" button variant tokens (control.brand.ghost, control.mono.ghost,
 * control.brandExtra.ghost, control.alert.ghost, and their text.ghost counterparts)
 * are developer-added tokens NOT present in the Figma design token exports.
 * Do NOT delete them when syncing tokens from Figma.
 *
 * Similarly, "appButton" tokens are developer-added (by r.tallmadge@xsolla.com).
 */
export const colors = {
  dark: pentagramDark,
  light: pentagramLight,
  "pentagram-dark": pentagramDark,
  "pentagram-light": pentagramLight,
  "ltg-dark": ltgDark,
  blueprints,
};

export type ThemeColors = typeof pentagramDark;
